import React, { useEffect, useState } from 'react';

import billingAppIcon from '../../../../../../assets/images/icons/billing-app.svg';
import billingDomainIcon from '../../../../../../assets/images/icons/billing-domain.svg';
import billingWebsiteIcon from '../../../../../../assets/images/icons/billing-website.svg';
import billingDemandApiIcon from '../../../../../../assets/images/icons/billing-demanApi.svg';
import './addOns.scss';
import { Badge, Button } from 'react-bootstrap';
import { FiMail } from 'react-icons/fi';
import { CiBadgeDollar } from 'react-icons/ci';
import { RiShieldCheckFill, RiSpeedUpFill } from 'react-icons/ri';
import { FaRegCalendarAlt } from 'react-icons/fa';
import Switch from 'react-switch';
import {
  onBoardingChangeAddOnsApi,
  onBoardingChangeAddOnsPreviewApi,
} from '../../../../../../constants/ApiConfigs';
import { callApiWithoutDispatch } from '../../../../../../utils/apiUtils';
import UpdateAddOns from '../UpdateAddOns';
import { formatDateBilling } from '../../../billingOverview/component/CreditGrants/CreditGrants';
import CCModal2025 from '../../../../../../components/ccModal2025';
import { BILLING_PLAN_TYPE } from '../../../../../../features/signup/constantStep';
import { I18n } from 'react-redux-i18n';
import { handleAddOnFee } from '../../../billingOverview/component/AddOnsReview';

const AddOns = ({
  billingUsage = {},
  auth,
  context,
  loadingActions,
  handleLoadBillingUsage,
  onResetPreviewBillingPlan,
  onAddOnsChange,
  onResetPreviewAddOns,
  permissions,
}) => {
  const [oldAddOns, setOldAddOns] = useState([]);
  const [newAddOns, setNewAddOns] = useState([]);
  const [
    isShowModalConfirmCancelSubscription,
    setIsShowModalConfirmCancelSubscription,
  ] = useState(false);
  const [itemConfirmCancelSubscription, setItemConfirmCancelSubscription] =
    useState(null);
  useEffect(() => {
    setOldAddOns(billingUsage?.addOns);
    setNewAddOns(transformNewAddOns);
  }, [billingUsage]);

  const transformNewAddOns = () => {
    const getAddOnsFee = (addOn) => {
      return handleAddOnFee(addOn, billingUsage);
    };
    const addOnsAvailableSettings = billingUsage?.addOnsSettings
      ?.filter((item) => item.isActive === true && item.showOnMarket)
      ?.map((item) => {
        const addOnsAdded = billingUsage?.addOns?.find(
          (i) => i.id === item._id
        );
        const addOn = {
          id: item._id,
          name: item.name,
          title: item.description,
          icon: billingDomainIcon,
          image: item?.image,
          isUsing: !!addOnsAdded,
          isChecked: addOnsAdded?.cancelAtPeriodEnd === false,
          cancelAtPeriodEnd: addOnsAdded?.cancelAtPeriodEnd,
          allowEmailBtn: item.allowEmailBtn,
          instructionUrl: item.instructionUrl,
          addOnsAdded,
          item: [...getAddOnsFee(item)],
        };
        return addOn;
      })
      ?.sort((a, b) => {
        if (a.addOnsAdded && !b.addOnsAdded) return -1;
        if (!a.addOnsAdded && b.addOnsAdded) return 1;
        return 0;
      });
    return addOnsAvailableSettings;
  };

  const handleCancelAddonUsing = (item, checked) => {
    if (!checked) {
      setIsShowModalConfirmCancelSubscription(true);
      setItemConfirmCancelSubscription(item);
      return;
    } else {
      handleResumeAddonUsing(item);
    }
  };

  const handleResumeAddonUsing = (item) => {
    submitChangeAddOn({ addOnIds: [item.id], removedAddOnIds: [] });
  };

  const confirmCancelAddonUsing = async () => {
    submitChangeAddOn({
      addOnIds: [],
      removedAddOnIds: [itemConfirmCancelSubscription.id],
    });
  };

  const submitChangeAddOn = async ({ addOnIds, removedAddOnIds }) => {
    try {
      console.log(
        'itemConfirmCancelSubscription',
        itemConfirmCancelSubscription
      );
      loadingActions.showLoadingSpiner();
      const response = await callApiWithoutDispatch(onBoardingChangeAddOnsApi, {
        method: 'POST',
        body: JSON.stringify({
          fleetId: auth?.selectedFleet?.fleetId,
          addOnIds,
          removedAddOnIds,
          paymentId: 'paymentId',
        }),
      });
      if (response?.res?.data) {
        context.notification('success', 'Add-on changed successfully');
        handleLoadBillingUsage();
        setIsShowModalConfirmCancelSubscription(false);
        setItemConfirmCancelSubscription(null);
        onResetPreviewBillingPlan();
        onResetPreviewAddOns();
      } else {
        context.notification('error', 'Failed to changed add-on');
      }
    } catch (error) {
      context.notification('error', 'Failed to changed add-on');
    } finally {
      loadingActions.hideLoadingSpiner();
    }
  };

  const handleChangeAddOn = (addOnItem, checked) => {
    if (addOnItem.isUsing) {
      handleCancelAddonUsing(addOnItem, checked);
      return;
    }
    const newAddOnsUpdated = newAddOns.map((item) => {
      if (item.id === addOnItem.id) {
        item.isChecked = checked;
      }
      return item;
    });
    setNewAddOns(newAddOnsUpdated);
    const { removedAddOnIds, addedAddOnIds } =
      handlePreviewAddOnsWhenChange(newAddOnsUpdated);
    onAddOnsChange({ removedAddOnIds, addOnIds: addedAddOnIds });
  };

  const handlePreviewAddOnsWhenChange = (newAddOnsUpdated) => {
    const removedAddOns = oldAddOns.filter((oldItem) =>
      newAddOnsUpdated.find(
        (newItem) => newItem.id === oldItem.id && !newItem.isChecked
      )
    );

    const addedAddOns = newAddOnsUpdated.filter(
      (newItem) =>
        newItem.isChecked &&
        !oldAddOns.some((oldItem) => oldItem.id === newItem.id)
    );

    const removedAddOnIds = removedAddOns.map((item) => item.id);
    const addedAddOnIds = addedAddOns.map((item) => item.id);

    return {
      removedAddOns,
      addedAddOns,
      removedAddOnIds,
      addedAddOnIds,
    };
  };

  const rendModalConfirmCancelSubscription = () => {
    return (
      <>
        <CCModal2025
          isShow={isShowModalConfirmCancelSubscription}
          onClose={() => {
            setIsShowModalConfirmCancelSubscription(false);
          }}
          onSubmit={confirmCancelAddonUsing}
          className="cancel-subscription-modal"
          title={I18n.t('billingUsage.cancelSubscription')}
          btnCloseText={I18n.t('billingUsage.no')}
          btnSubmitText={I18n.t('billingUsage.yes')}
          size="sm"
        >
          <p>
            {I18n.t('billingUsage.areYouSureCancelSubscription')}{' '}
            <span style={{ color: '#F04438' }}>
              {I18n.t('billingUsage.until')}{' '}
              {formatDateBilling(billingUsage.currentPeriodEnd)}
            </span>
          </p>
        </CCModal2025>
      </>
    );
  };

  return (
    <>
      {rendModalConfirmCancelSubscription()}
      <div className="add-ons-subscription">
        <h3>{I18n.t('billingUsage.addOns')}</h3>
        <p className="add-on-description">
          {I18n.t('billingUsage.enableOnlyWhatYouNeed')}
        </p>
        <div className="add-ons-items">
          {[...newAddOns]?.map((item, index) => (
            <div className="add-on-item" key={index}>
              <div className="add-on-icon">
                <img
                  src={
                    item.image
                      ? `${auth?.selectedFleet?.s3Host}${item.image}`
                      : item.icon
                  }
                  style={{ maxWidth: '30px' }}
                />
                {item.addOnsAdded ? (
                  <Badge className="badge-note">{I18n.t('billingUsage.subscribed')}</Badge>
                ) : item.allowEmailBtn ? (
                  <Button
                    className="btn-header btn btn-contact-us"
                    href={`mailto:support@goodjourney.io?subject=${encodeURIComponent(`Request to Activate Add-On: ${item.name}`)}&body=${encodeURIComponent(`Hello Good Journey Team,

We'd like to request activation of the following add-on on our account:

Add-On: ${item.name}

Company / Fleet Name: ${auth?.selectedFleet?.fleetId || ''}

Account Email: ${auth?.selectedFleet?.email || ''}

Thank you, and we look forward to your confirmation.`)}`}
                  >
                    <FiMail />
                    <span>{I18n.t('billingUsage.contactUs')}</span>
                  </Button>
                ) : null}
              </div>
              <div className="add-on-content">
                <h4>{item.name}</h4>
                <p className="add-on-title" style={{ whiteSpace: 'pre-line', color: 'rgba(203, 213, 225, 1)' }}>{item.title}</p>
                {item.instructionUrl && (
                  <p style={{ marginBottom: '10px' }}>
                    <a style={{ fontSize: '14px', color: '#04BE76', textDecoration: 'none' }} href={item.instructionUrl} target="_blank" rel="noopener noreferrer">
                      {I18n.t('billingUsage.learnMore')}
                    </a>
                  </p>
                )}
                <div
                  className="add-on-item-container"
                  style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}
                >
                  {item?.item?.map((item, index) => (
                    <div className="add-on-item-content" key={index}>
                      <div className="add-on-item-text">
                        {item.icon}
                        <span>{item.text}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {item.cancelAtPeriodEnd === true && item?.item?.some(item => item.type === 'fee') && (
                <p
                  className="add-on-item-content"
                  style={{ color: '#F04438', fontSize: '12px' }}
                >
                  <span>
                    {I18n.t('billingUsage.endOfSubscription')}:{' '}
                    {formatDateBilling(billingUsage.currentPeriodEnd)}
                  </span>
                </p>
              )}
              {!item.allowEmailBtn && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: '15px',
                  }}
                >
                  <Switch
                    checked={item.isChecked}
                    onChange={(checked) => handleChangeAddOn(item, checked)}
                    offColor="#363A44"
                    onColor="#04BE76"
                    offHandleColor="#ffffff"
                    onHandleColor="#ffffff"
                    handleDiameter={20}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    height={24}
                    width={48}
                    className="billing-switch-component"
                    disabled={!permissions.actions}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default AddOns;
